module.exports = __webpack_public_path__ + "static/media/logo192.d86b75ed.png";